module.exports = "pegasus/assets/gray-ghost-twitter.png";